import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { AppInput } from "../global/AppInput";

const Search = ({
  collection,
  type,
  className,
  inputClass,
  collectionClass,
  prepend,
  append,
  onChange,
}) => {
  const [keyword, setKeyword] = useState(``);
  const [filteredCollection, setFilteredCollection] = useState([]);

  const keywordHandler = (e) => {
    setKeyword(e.target.value.toLowerCase());
    onChange?.(e.target.value);
  };

  useEffect(() => {
    if (collection) {
      setFilteredCollection(collection);
    }
  }, [collection]);

  useEffect(() => {
    if (keyword && collection) {
      if (keyword.length > 0) {
        setFilteredCollection(
          collection.filter((tour) =>
            tour.title.toLowerCase().includes(keyword)
          )
        );
      } else {
        setFilteredCollection([]);
      }
    }
  }, [keyword, collection]);

  return (
    <div
      className={`w-full md:w-[565px] flex items-center flex-wrap mx-auto lg:mx-0 rounded-[10px] ${className}`}
    >
      <div className={`w-full ${inputClass}`}>
        <div className="w-full flex items-center bg-white px-2 rounded-lg">
          {prepend}
          <AppInput
            placeholder={`Search ${type}`}
            className="pb-3 placeholder:text-night-blue border-transparent"
            onChange={keywordHandler}
          />
          <i className="iconify font-bold" data-icon="ion:search" />
        </div>
        {append}
      </div>
      {keyword.length && filteredCollection.length ? (
        <div
          tabIndex="0"
          className={`w-full menu shadow bg-white rounded-box relative`}
        >
          <ul
            className={`w-full absolute left-0 top-0 z-10 mt-2 ${collectionClass}`}
          >
            {filteredCollection.map((ele, index) => (
              <li key={index} className="bg-white hover:bg-yellow">
                {type && (
                  <Link
                    to={
                      type === "partner"
                        ? `/${type}/${ele.slug}`
                        : type === "tour"
                        ? `/${type}/${ele.slug}/demo`
                        : ""
                    }
                    id="en"
                  >
                    {ele.title}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default Search;
